import { EpimsBaseEntityDto } from './epim-base.dto';
export class CategoryDto extends EpimsBaseEntityDto {

    id: string;
    CategoryName: string;
    SubscriptionUserId: string;
    SubscriberId: string;
    dateCreated: Date;
    dateUpdated?: Date;
    CreatedById: string;
    ModifiedById: string;
    SiteId: string;
    Version: number;
}